import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 日志上报
export function submitReport(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.SUBMIT_REPORT, option);
}
